import request from '@core/services/request';

export const dataDefinitionsAPI = {
	richtable: (req: any) => request.post(`/DataDefinitions/richtable`, req),
	get: (id: any) => request.get(`/DataDefinitions/${id}`),
	create: (name: any, type: any) => request.post(`/DataDefinitions?name=${name}&type=${type}`),
	update: (datadefinition: any, copyToProd: boolean = false) => request.put(`/DataDefinitions?copyToProd=${copyToProd}`, datadefinition),
};
